import React from 'react';
import LastTimeLogoAnimationPlayedContainer from '../containers/logo_animation_container';

const LogoAnimationContext = React.createContext(new LastTimeLogoAnimationPlayedContainer());

export default LogoAnimationContext;
